import { FetchClientScopesRoutine } from '../routines';

export const initialState = {
  isFetching: false,
  data: [],
  error: null
};

export const clientScopesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FetchClientScopesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchClientScopesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchClientScopesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
